import React from 'react';
import { Box, Container } from '../primitives';
import { useTheme } from '@mui/material/styles';

/**
 * Composed PageContainer component
 * Reusable container for page layouts
 */
const PageContainer = ({ children, maxWidth = 'lg', ...props }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(3),
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
      }}
      {...props}
    >
      <Container maxWidth={maxWidth}>
        {children}
      </Container>
    </Box>
  );
};

export default PageContainer;

